import Vue from "vue";
import VueRouter from "vue-router";
import ShareResult from "@/components/ShareResult";
import Home from "@/components/Home";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/:lang",
    name: "Lang",
    component: Home
  },
  {
    path: "/:lang/share/result",
    name: "ShareResult",
    component: ShareResult
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.VUE_APP_ROOT_URL,
  routes
});

export default router;